export const schedule = {
  go: {
    start: "ابدأ",
    cantNow: "لا يمكنني الآن",
    details: "التفاصيل",
  },
notFound: "الجدولة غير موجودة",
loadError: {
title: "تعذر تحميل هذا الجدول",
description: "تحقق من اتصالك وحاول مرة أخرى.",
},
startFailed: "غير قادر على بدء هذا الفحص.",
starting: "جارٍ البدء...",
loadingAsset: "جارٍ تحميل الأصل…",
breadcrumb: {
backToRequest: "← العودة إلى الطلب",
scheduledInspection: "فحص مجدول",
},
calendarInvite: {
titleWithAsset: "فحص: {{asset}}",
titleFallbackAsset: "أصل",
descriptionChecklist: "قائمة التحقق: {{name}}",
addToCalendar: "إضافة إلى التقويم",
notNow: "ليس الآن",
confirmedTitle: "تم تأكيد الموعد",
confirmedBody: "تم إبلاغ الفريق. هل تريد إضافة الزيارة إلى تقويمك؟",
},
sourceRequest: {
title: "من الطلب",
fallback: "يظل هذا الفحص المجدول مرتبطًا بالسجل الزمني للطلب الأصلي.",
openRequest: "فتح الطلب",
},
visit: {
label: "الزيارة",
confirmed: "أكّدتها جهة الاتصال",
awaitingConfirmation: "بانتظار تأكيد جهة الاتصال",
},
readOnlyAssetNotice: "تتم مشاركة هذا الأصل معك للقراءة فقط، لذلك لا يمكن بدء الفحص عليه. اطلب من مالكه حق الوصول للتعديل، أو قم بإجراء هذا الفحص من أحد الأصول الموجودة في مساحة العمل الخاصة بك.",
reschedule: {
accessibilityLabel: "إعادة جدولة التفتيش",
label: "إعادة الجدولة",
},
changeRequest: {
sent: "تم إرسال الطلب",
savedOffline: "تم الحفظ على هذا الجهاز — سيتم الإرسال عند عودة الاتصال بالإنترنت",
sendFailed: "تعذر إرسال الطلب",
decideFailed: "تعذر تسجيل القرار",
photosNeedSignal: "تحتاج الصور إلى إشارة للرفع. أزلها لحفظ هذا الطلب دون اتصال، أو حاول مرة أخرى عند عودة الاتصال بالإنترنت.",
},
overflow: {
moreActionsLabel: "المزيد من إجراءات الجدول الزمني",
sheetTitle: "خيارات الجدول الزمني",
},
status: {
  skipped: "تم التخطي",
upcoming: "قادمة",
due: "مستحقة الآن",
overdue: "متأخرة",
completed: "مكتملة",
cancelled: "ملغاة",
},
alerts: {
errorTitle: "خطأ",
templateMissing: "لم يتم العثور على قائمة التحقق.",
cancelTitle: "إلغاء الجدولة",
cancelMessage: "هل أنت متأكد أنك تريد إلغاء هذا التفتيش المجدول؟",
cancelConfirm: "إلغاء الجدولة",
no: "لا",
deleteTitle: "حذف الجدولة",
deleteMessage: "سيتم حذف هذه الجدولة نهائيًا.",
deleteConfirm: "حذف",
},
labels: {
asset: "أصل",
checklist: "قائمة تحقق",
assignedTo: "مُسند إلى",
unassigned: "غير مُسند",
recurrence: "التكرار",
reminders: "التذكيرات",
none: "لا شيء",
seriesEndDate: "نهاية السلسلة (تاريخ)",
seriesEndTime: "نهاية السلسلة (وقت)",
maxCompletedRuns: "يتوقف بعد",
},
seriesEnd: {
sectionTitle: "حدود السلسلة (اختياري)",
helper: "اتركه فارغًا إذا لم ترد وضع حد. تتوقف السلسلة عند بلوغ أيٍّ من الحدّين.",
maxPlaceholder: "مثلًا 12",
errors: {
maxPositive: "أدخل عددًا صحيحًا ≥ 1 أو اترك الحقل فارغًا.",
invalidEnd: "تاريخ أو وقت النهاية غير صالح.",
endBeforeStart: "يجب أن تكون نهاية السلسلة في أو بعد وقت البدء المجدول.",
},
},
detail: {
  stopRepeat: {
    failed: "تعذّر إيقاف التكرار. تحقق من اتصالك وحاول مرة أخرى.",
    done: "لم يعد هذا الفحص يتكرر.",
    confirm: "إيقاف التكرار",
    message: "تبقى هذه الزيارة، ولن تُنشأ زيارات أخرى بعدها.",
    title: "إيقاف تكرار هذا الفحص؟",
    action: "إيقاف التكرار",
  },
seriesEnds: "ينتهي التكرار",
maxRuns_zero: "يتوقف بعد {{count}} زيارة",
maxRuns_one: "يتوقف بعد زيارة واحدة",
maxRuns_two: "يتوقف بعد زيارتين",
maxRuns_few: "يتوقف بعد {{count}} زيارات",
maxRuns_many: "يتوقف بعد {{count}} زيارة",
maxRuns_other: "يتوقف بعد {{count}} زيارة",
unlimitedRuns: "بلا حد",
noEndDate: "لا يوجد تاريخ انتهاء",
},
list: {
untilDate: "حتى {{date}}",
maxRunsChip_zero: "حتى {{count}} زيارة",
maxRunsChip_one: "حتى زيارة واحدة",
maxRunsChip_two: "حتى زيارتين",
maxRunsChip_few: "حتى {{count}} زيارات",
maxRunsChip_many: "حتى {{count}} زيارة",
maxRunsChip_other: "حتى {{count}} زيارة",
typeInspection: "تفتيش",
typeJob: "مهمة",
filterActive: "نشط",
filterPast: "سابق",
filterAll: "الكل",
overdueChip: "متأخر",
scheduleWork: "جدولة عمل",
scheduleSheetTitle: "ما الذي تريد جدولته؟",
emptyTitle: "لا يوجد شيء مجدول",
emptyActiveSubtitle: "قم بجدولة تفتيش أو مهمة وسيظهر هنا.",
emptyPastSubtitle: "لا توجد أعمال مجدولة سابقة.",
emptyAllSubtitle: "لا توجد أعمال مجدولة بعد.",
},
unknownAsset: "أصل غير معروف",
unknownChecklist: "قائمة تحقق غير معروفة",
templateMeta_one: "عنصر واحد · {{category}}",
templateMeta_other: "{{count}} عنصر · {{category}}",
recurrence: {
none: "لمرة واحدة",
hourly: "كل ساعة",
daily: "كل يوم",
weekly: "كل أسبوع",
biweekly: "كل أسبوعين",
monthly: "كل شهر",
quarterly: "كل 3 أشهر",
yearly: "كل سنة",
},
reminder: {
at_time: "في الوقت المجدول",
"15min": "قبل 15 دقيقة",
"30min": "قبل 30 دقيقة",
"1hr": "قبل ساعة",
"2hr": "قبل ساعتين",
"1day": "قبل يوم",
"2day": "قبل يومين",
},
actions: {
startNow: "ابدأ التفتيش الآن",
startFor: "ابدأ نيابةً عن {{name}}",
cancelSchedule: "إلغاء الجدولة",
viewInspection: "عرض التفتيش",
delete: "حذف",
},
planner: {
subtitle: "اختر تاريخًا، وعيّن شخصًا، وثبّت الموعد.",
scheduleCta: "جدولة",
scheduleInspection: "جدولة تفتيش",
scheduleJob: "جدولة أمر عمل",
},
create: {
createChecklistCta: "إنشاء قائمة تحقق",
noChecklistsHint: "لا توجد قوائم تحقق بعد. أنشئ قائمة للمتابعة بالجدولة.",
overlayReturnFootnote: "يفتح كطبقة فوق الشاشة. بعد الحفظ تعود هنا والقائمة المختارة جاهزة.",
ctaAccessibility: "إنشاء قائمة تحقق والعودة إلى الجدولة",
},
templateMeta_zero: "لا عناصر · {{category}}",
templateMeta_two: "عنصران · {{category}}",
templateMeta_few: "{{count}} عناصر · {{category}}",
templateMeta_many: "{{count}} عنصرًا · {{category}}",
};
